<template>
		<st-toast-confirm
			v-model="visible"
			whereClose="none"
			:showCancel="false"
			title="提示"
			confirmText="确定"
			@onConfirm="onConfirm">
			<img src="http://resliti.lititutu.cn/tuku/prod/9a83c8c013398fb109264ce712fe28f7.png" style="width: 95%; display: block; margin: 0 auto;">
			<div style="text-align: center; color: #999; font-size: 18px; margin-top: 10px;">点击「确定」返回微信「搜索」</div>
		</st-toast-confirm>
	</template>

	<script>
		import StToastConfirm from '@/components/st_comps/st_comp/comps/StToast/StToastConfirm.vue'

		export default {
			name: 'MakeByWxsearchToast',
			components: {
				StToastConfirm
			},
			model: {
				prop: 'show',
				event: 'change'
			},
			props: {
				show: {
					type: Boolean,
					default: false
				}
			},
			computed: {
				visible: {
					get () {
						return this.show
					},
					set (val) {
						this.$emit('change', val)
					}
				}
			},
			methods: {
				onConfirm () {
					this.$emit('confirm')
					this.visible = false
				}
			}
		}
	</script>
